import { Base64 } from 'js-base64'
import { getApiConfig } from "@/utils/request";

const apiConfig = getApiConfig()
export const helpcenterMap = {
  0: `${apiConfig.helpCenter}/help-center/${apiConfig.LOCAL_CID}`, // 本地
  1: `${apiConfig.helpCenter}/help-center/${apiConfig.ZHCN_CID}`  
}
export const toHelpCenter = (isGlobal: number) => {
  
  const path = helpcenterMap[isGlobal]
  path && window.open(path)
}

export const toHelpCenterDetail = (
  isGlobal: number,
  articleId: number,
  categoryId: string
) => {
  const cid = isGlobal === 1 
    ? apiConfig.ZHCN_CID 
    : apiConfig.LOCAL_CID

  let path = `${apiConfig.helpCenter}/help-center/detail/${articleId}?cid=${cid}&aid=${categoryId}`

  window.open(path)
}

/**
 * 生成随机len位数字
 */
export const randomLenNum = (len: Number, date: Boolean) => {
  let random = ''
  random = Math.ceil(Math.random() * 100000000000000).toString().substr(0, typeof len === 'number' ? len : 4)
  if (date) random = random + Date.now()
  return random
}
/**
 * Base64
 */
export const base64 = {
  decode: (datas: string) => {
    return Base64.decode(datas)
  },
  encode: (datas: string) => {
    return Base64.encode(datas)
  }
}
/**
 * 日期格式化
 */
export const tiemstap = function (fmt: any): any {
  if (!fmt || fmt.length < 5) {
    return ''
  }
  if (fmt.length === 10) {
    fmt = fmt * 1000
  }
  const time = new Date(fmt);
  const Y = time.getFullYear()
  const M = (time.getMonth() + 1).toString().padStart(2, '0')
  const D = time.getDate().toString().padStart(2, '0')
  const h = time.getHours().toString().padStart(2, '0')
  const m = time.getMinutes().toString().padStart(2, '0')
  const s = time.getSeconds().toString().padStart(2, '0')
  return `${Y}-${M}-${D} ${h}:${m}:${s}`
}

/**
 * 指定转换为对应时区
 * @param {Date} t 当前时间 毫秒(ms)或日期
 * @param {Number} num 是与UTC时差 如肯尼亚为 3个小时 北京为8个小时 
 * @param {Boolean} timezone 传入的t是时间戳还是日期, timezone为true时,表示为时间戳,返回值也为时间戳,反之为日期时同理
 * @returns Date 转后后的本地时间
 */
export const timezoneConvert = function (t: any, e: number = 3, timezone: boolean = true) {
  const localDate = new Date()
  var localOffset = localDate.getTimezoneOffset() * 60000;
  var newTime = typeof t === 'number' ? (t + localOffset + (e * 3600000)) : new Date(t).getTime() + localOffset + (e * 3600000);

  return timezone ? newTime : new Date(newTime)
}
let MenuItem = [
  {
    name: '首页',
    icon: 'bx-home',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
    meta: {
      title_en: 'Home Page',
      title: '首页'
    },
    path: "/home",
    component: () => import('@/views/Kilimall/seller/Home.vue'),

  },
  {
    name: '商品',
    icon: 'bx-shopping-bag',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
    meta: {
      title_en: 'Product',
      title: "商品"
    },
    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    children: [
      {
        name: "新增商品",
        path: "/KiliMall/categoryVue",
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Add New Product',
          title: "新增商品"
        },
        component: () => import('@/views/Kilimall/seller/categoryCheck.vue'),
        children: [
        ]
      },
      {
        name: "管理商品",
        path: "/KiliMall/goodsList",
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口     
        meta: {
          title_en: 'All Product',
          title: "管理商品"
        },
        component: () => import('@/views/Kilimall/seller/goodsList.vue'),
        children: [
        ]
      },
      {
        name: "违规商品",
        path: "index.php?act=store_goods_offline&op=index&type=lock_up&no_prefix=1",
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口    
        meta: {
          title_en: 'Violating Rule Products',
          title: "违规商品"

        },
        children: [
        ]
      },
      {
        name: "草稿箱",
        path: "/KiliMall/drafts",
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Draft Box',
          title: "草稿箱"
        },
        children: [],
        component: () => import('@/views/Kilimall/seller/drafts.vue'),
      },
      {
        name: "素材空间",
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        icon: 'el-icon-location',
        meta: {
          title_en: 'Image & Video Gallery',
          title: "素材空间"
        },
        path: "index.php?act=store_album&op=album_cate&no_prefix=1",
        children: [
        ]
      },
      {
        name: "品牌申请",
        path: "/KiliMall/brandApply",
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口 
        icon: 'el-icon-location',
        meta: {
          title_en: 'Brand Application',
          title: "品牌申请"
        },
        children: [
        ],
        component: () => import('@/views/Kilimall/seller/brandApply.vue')
      },
      {
        name: "备货邀请计划",
        icon: 'el-icon-location',
        path: "/KiliMall/restockPlanning/restockPlanning",
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Restock Invitations',
          title: "备货邀请计划"
        },
        children: [],
        component: () => import('@/views/Kilimall/manage/restockPlanning/restockPlanning.vue')
      },
      {
        name: "备货申请",
        icon: 'el-icon-location',
        meta: {
          title_en: 'FBK Warehouse Stock Application',
          title: "备货申请"
        },
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        children: [
        ],
        path: "index.php?act=store_storage&op=index&no_prefix=1",
      },
      {
        name: "库存管理",
        icon: 'el-icon-location',
        path: "index.php?act=store_goods_offline&op=index&type=product_stocks&no_prefix=1",
        meta: {
          title_en: 'Inventory Management',
          title: "库存管理"
        },
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        children: [
        ]
      },
      {
        name: "库存预警",
        icon: 'el-icon-location',
        path: "index.php?act=sales_forecast&op=index&no_prefix=1",
        meta: {
          title_en: 'Inventory Shortage Warning',
          title: "库存预警"
        },

        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        children: [
        ]
      },
    ]
  },
  {
    name: '订单',
    icon: 'bx-slider-alt',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    meta: {
      title_en: 'Order',
      title: "订单"
    },
    children: [
      {
        name: '订单发货',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        path: "index.php?act=store_order&op=store_order&state_type=state_pay&no_prefix=1",
        meta: {
          title_en: 'Dispatch Order',
          title: "订单发货"
        },
        children: [],
      },
      {
        name: '管理订单',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        path: "index.php?act=store_order&op=index&no_prefix=1",
        meta: {
          title_en: 'All Orders',
          title: "管理订单"
        },
        children: [],
      },
    ]
  },
  {
    name: '促销',
    icon: 'bx-purchase-tag',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    meta: {
      title_en: 'Promotion',
      title: "促销"
    },
    children: [
      {
        name: '平台活动',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        component: () => import('@/views/Kilimall/seller/ActiveBackstage/index.vue'),
        path: "/KiliMall/ActiveBackstage",
        meta: {
          title_en: 'Platform Event',
          title: "平台活动"
        },
        children: [],
      },
      {
        name: '秒杀',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        component: () => import('@/views/Kilimall/seller/FlashSales/index.vue'),
        path: "/KiliMall/FlashSales",
        meta: {
          title_en: 'Flash Sale',
          title: "秒杀"
        },
        children: [],
      },
      {
        name: '优惠券',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        path: "index.php?act=seller_voucher&op=&no_prefix=1",
        meta: {
          title_en: 'Voucher',
          title: "优惠券"
        },
        children: [],
      },
      {
        name: '付费推广',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        component: () => import('@/views/Kilimall/seller/PaidPromotion/index.vue'),
        path: "/KiliMall/PaidPromotion",
        meta: {
          title_en: 'Sponsored Products',
          title: "付费推广"
        },
        children: [],
      },
      {
        name: '限时折扣',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        path: "index.php?act=store_promotion_xianshi&op=xianshi_list&no_prefix=1",
        meta: {
          title_en: 'Time Limited Discount',
          title: "限时折扣"
        },
        children: [],
      },
      {
        name: '新手专区',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        path: "index.php?act=supply_newuser&op=index&no_prefix=1",
        meta: {
          title_en: 'New User Zone',
          title: "新手专区"
        },
        children: [],
      },
    ]
  },
  {
    name: '服务',
    icon: 'bx-support',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

    meta: {
      title_en: 'Service',
      title: "服务"
    },
    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    children: [
      {
        name: '客户聊天',
        icon: 'el-icon-location',
        type: 3, // 1路由页面、  2Iframe加载 、 open新窗口     
        path: "new/message",
        children: [],
        meta: {
          title_en: 'Customer Chat',
          title: "客户聊天"
        },
      },
      {
        name: '商品反馈',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        path: '/KiliMall/ReviewMangmen',
        meta: {
          title_en: 'Product Review',
          title: "商品反馈"
        },
        children: [],
        component: () => import('@/views/Kilimall/seller/ReviewMangmen.vue'),
      },
      {
        name: '售后管理',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Aftersale Management',
          title: "售后管理"
        },
        path: 'index.php?act=apply_return&op=index&no_prefix=1',
        children: [],
      },
      {
        name: '新售后管理',
        icon: 'el-icon-location',
        // store_id: [ 5250 , 693, 5733, 1645], // 线上环境的四个店铺id打开售后功能
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'New Aftersale Management',
          title: "新售后管理"
        },
        path: '/KiliMall/afterSale/afterList',
        children: [],
      },
      // {
      //   name: '客户取消订单管理',
      //   icon: 'el-icon-location',
      //   type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
      //   meta:{
      //     title_en:'Customer Cancellation Orders', 
      //     title:"客户取消订单管理"
      //   },
      //   path:"index.php?act=apply_cancel_order&op=index&no_prefix=1",
      //   children:[],
      // },
    ]
  },
  {
    name: '洞察',
    icon: 'bx-bar-chart-alt',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
    meta: {
      title_en: 'Insights',
      title: "洞察"
    },
    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    children: [
      {
        name: '店铺报告',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Store Report',
          title: "店铺报告"
        },
        path: "index.php?act=statistics_general&op=general&no_prefix=1",
        children: [],
      },
      {
        name: '商品报告',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          title_en: 'Product Report',
          title: "商品报告"
        },
        path: "/KiliMall/BusinessReport",
        children: [],
        component: () => import('@/views/Kilimall/seller/BusinessReport/index.vue'),
      },
      {
        name: '销量报告',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Sales Report',
          title: "销量报告"
        },
        path: "index.php?act=statistics_sale&op=sale&no_prefix=1",
        children: [],
      },
      {
        name: '流量报告',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Traffic Report',
          title: "流量报告"
        },
        path: "index.php?act=statistics_flow&op=storeflow&no_prefix=1",
        children: [],
      },

    ]
  },
  {
    name: '财务',
    icon: 'bx-data',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
    meta: {
      title_en: 'Finance',
      title: "财务"
    },
    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    children: [
      {
        name: "结算账单",
        path: "/Seller/billManage/billReport",
        store_id: [5331, 6297, 6213, 6118, 2195, 7593, 1, 5169, 6220, 7153, 5800],
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Statements',
          title: "结算账单"
        },
        component: () => import('@/views/Kilimall/seller/billManage/billReport.vue'),
        children: [
        ]
      },
      {
        name: "账单明细",
        path: "/Seller/billManage/accountReport",
        icon: 'el-icon-location',
        store_id: [5331, 6297, 6213, 6118, 2195, 7593, 1, 5169, 6220, 7153, 5800],
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Statements',
          title: "账单明细"
        },
        component: () => import('@/views/Kilimall/seller/billManage/accountReport.vue'),
        children: [
        ]
      },
      {
        name: "账单查询",
        path: "/Seller/billManage/billQuiry",
        // store_id: [5331, 6297, 6213, 6118, 2195, 7593, 1, 5169, 6220, 7153, 5800],
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Settlement inquiry',
          title: "账单查询"
        },
        component: () => import('@/views/Kilimall/seller/billManage/billQuiry.vue'),
        children: [
        ]
      },
      {
        name: '头程运费账单',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'Cross Boarder Shipment Billing',
          title: "头程运费账单"
        },
        path: "/KiliMall/error",
        children: [],
      },
      {
        name: '交易详情',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'Transaction Details',
          title: "交易详情"
        },
        path: "/KiliMall/error",
        children: [],
      },
      {
        name: '收款银行账号',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'Bank Account',
          title: "收款银行账号"
        },
        path: "/KiliMall/error",
        children: [],
      },
    ]
  },
  {
    name: '店铺',
    icon: 'bx-store',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
    meta: {
      title_en: 'Store',
      title: "店铺"
    },
    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    children: [
      {
        name: '店铺基本信息',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Store Basic Information',
          title: "店铺基本信息"
        },
        path: "index.php?act=store_setting&op=store_setting&no_prefix=1",
        children: [],
      },
      {
        name: '店铺导航',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Store Decoration',
          title: "店铺导航"
        },
        path: "index.php?act=store_navigation&op=navigation_list&no_prefix=1",
        children: [],
      },
      {
        name: '店铺自定义品类',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: ' Store Category',
          title: "店铺自定义品类"
        },
        path: "index.php?act=store_goods_class&op=index&no_prefix=1",
        children: [],
      },
      {
        name: '店铺发货地址',
        icon: 'el-icon-location',
        type: 2, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Store Shipping Address',
          title: "店铺发货地址"
        },
        path: "index.php?act=store_deliver_set&op=daddress_list",
        children: [],
      },
      {
        name: '售后发货地址',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Shipping Address',
          title: "售后发货地址"
        },
        path: "/KiliMall/shipAddress",
        component: () => import('@/views/Kilimall/seller/StoreAddress/index.vue'),
        children: [],
      },
      {
        name: '售后收货地址',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
        meta: {
          title_en: 'Return Address',
          title: "售后收货地址"
        },
        path: "/KiliMall/shippingAddress",
        component: () => import('@/views/Kilimall/seller/StoreAddress/index.vue'),
        children: [],
      },
    ]
  },
  {
    name: '商户设置',
    icon: 'bx-wrench',
    type: 1, // 1路由页面、  2Iframe加载 、 open新窗口
    meta: {
      title_en: 'Seller Settings',
      title: "商户设置"
    },
    path: '/KiliMall/product',
    component: () => import('@/views/Kilimall/seller/product.vue'),
    children: [
      {
        name: '商户基本信息管理',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'Seller Basic Information',
          title: "商户基本信息管理"
        },
        path: "/KiliMall/error",
        children: [],
      },
      {
        name: '店铺管理',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'Store Management',
          title: "店铺管理"
        },
        path: "/KiliMall/error",
        children: [],
      },
      {
        name: '员工管理',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'User Management',
          title: "员工管理"
        },
        path: "/KiliMall/error",
        children: [],
      },
      {
        name: '账户管理',
        icon: 'el-icon-location',
        type: 1, // 1路由页面、  2Iframe加载 、 open新窗口

        meta: {
          disabled: true,
          title_en: 'Account Management',
          title: "账户管理"
        },
        path: "/KiliMall/error",
        children: [],
      },

    ]
  },
]
export const menuRouter = () => {
  return new Promise((resolve, reject) => {
    resolve(MenuItem)

  })
}


/**
 * 千分位格式（字符）
 * @param symbol
 * @returns {string}
*/

interface String {
  thousands(): void,

}
// @ts-ignore
String.prototype.thousands = function (): string {
  let price = this.toString().replace('.00', '')
  return price.replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g, "$1,")
}

/**
 * 千分位格式（数字）
 * @param symbol
 * @returns {string}
 */
interface Number {
  thousands(): string
}
// @ts-ignore              
Number.prototype.thousands = function (): string {
  return this.toString().thousands()
}

/**
 * 嵌套深层次拷贝
 */
export function isArray(val: any) {//检测数组 
  //通过Object.prototype.toString.call来精准检测类型  
  return Object.prototype.toString.call(val) === '[object Array]';
}
function isObject(val: any) {//检测对象 
  return typeof val === 'object' && val !== null;
}
export function deepCopy(obj2: Object | Array<any>) {//递归深层copy
  /**
   * 把一个对象递归拷贝给另外一个对象
   * 源对象与拷贝后的对象没有引用关系
   */
  var obj: Object | Array<any> = isArray(obj2) ? [] : {};
  for (var property in obj2) {
    // 如果当前拷贝的数据还是一个对象的话，那么继续调用
    // deepCopy 进行二次拷贝
    // 递归
    if (isObject(obj2[property])) {
      obj[property] = deepCopy(obj2[property]);
    } else {
      obj[property] = obj2[property];
    }
  }
  return obj;
}



